export const TRANSLATION = 'builder.resume_editor.resume_writing'
